import { createAction } from 'redux-promise-middleware-actions'

export const RESET_STATE = 'RESET_STATE'

export const resetState = createAction(RESET_STATE, () => null)
